import React,{ useEffect, useState , useRef } from 'react';
import CollectionImages from './CollectionImages';
import DeliveryImages from './DeliveryImages';
import SignatureCanvas from 'react-signature-canvas'
import { FaRegCheckCircle } from "react-icons/fa";
import { FiArrowRightCircle } from "react-icons/fi";
import { PiMinusCircle } from "react-icons/pi";
import { PiPlusCircle } from "react-icons/pi";
import 'bootstrap';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import useLocalStorageState from 'use-local-storage-state';
import axios from 'axios';
import { useParams } from "react-router";
import { useNavigate } from 'react-router-dom';
import Navbar from "./Navbar";
const Jobs = () => {  
	let { id } = useParams();
	const navigate = useNavigate();
	const [token, setToken] = useLocalStorageState('token', '');
	const [data, setData] = useState([]);
	const [errcustomername,setErrcustomername]=useState('')
	const [errcustomersign,setErrcustomersign]=useState('')
	const [vehiclesdata, setVehiclesdata] = useState([]);
	const [isSignatureVisible, setIsSignatureVisible] = useState('true');
	const sigRef = useRef();
	const [signature, setSignature] = useState(null);	
	const [customername,setCustomername]=useState(null)	
	const [customernote,setCustomernote]=useState(null)	
	const [deliveryMark1,setDeliveryMark1]=useState('blockDiv')
	const [deliveryMark2,setDeliveryMark2]=useState('clearDiv')
	const [vehiclecnt,setVehiclecnt]=useState(0)
	const [stile,setStile]=useState(['storedImages','storedImages','storedImages','storedImages','storedImages','storedImages','storedImages','storedImages','storedImages','storedImages'])
	const [imgbtn,setImgbtn]=useState([<PiPlusCircle/>,<PiPlusCircle/>,<PiPlusCircle/>,<PiPlusCircle/>,<PiPlusCircle/>,<PiPlusCircle/>,<PiPlusCircle/>,<PiPlusCircle/>,<PiPlusCircle/>,<PiPlusCircle/>])
	const [canvasWidth, setCanvasWidth] = useState(window.innerWidth * 0.75);
	const LoadJob =async()=>
		{
		  let endpoint = process.env.REACT_APP_PHP_URL+'job-details';
		  const formData = {job_id:id}
			const BEARER_TOKEN = token;
			try{
			const response= await axios(endpoint, {
			  method: "POST",
			  data:formData,
			  withCredentials: true,
			  headers: {
				'Authorization': `Bearer ${BEARER_TOKEN}`,
				'Content-Type': 'application/json',
			}
			  });
					setData(response.data.data);
					setVehiclesdata(response.data.data[0].vehicles);
					setVehiclecnt(response.data.data[0].vehicles.length);
			}catch(error){
				navigate('/');
			  }
		}
  useEffect(() => {
	LoadJob();
  },[]);

	const openCollectionBlock=async()=>{
		setDeliveryMark1('clearDiv');
		setDeliveryMark2('blockDiv');
		setIsSignatureVisible(!isSignatureVisible);
		/*setStile(prevItems => 
			prevItems.map((item, idx) => 'storedImagesDisp')
		  );
		setImgbtn(prevItems => 
			prevItems.map((item, idx) => <PiMinusCircle />)
		  );*/	
		  //window.scrollTo({ top: 0, behavior: 'smooth' });btnSub
		  setTimeout(() => {
			//const el = document.getElementById("customerName");
			//el?.focus();
			document.getElementById("note").scrollIntoView({ behavior: "smooth" });
		  }, 50);
	}
	  const handleSignatureEnd = () => {
		setSignature(sigRef.current.toDataURL());
	  }
	  const clearSignature = () => {
		sigRef.current.clear();
		setSignature(null);
	  }
	const openImageBlock=(a)=>
		{
				if(stile[a]==='storedImagesDisp')
				{
					setStile(prevItems => 
						prevItems.map((item, idx) => idx === a ? 'storedImages' : stile[idx])
					  );
					  setImgbtn(prevItems => 
						prevItems.map((item, idx) => idx === a ? <PiPlusCircle /> : imgbtn[idx])
					  );					  				
				}
				else if(stile[a]==='storedImages'){
					setStile(prevItems => 
						prevItems.map((item, idx) => idx === a ? 'storedImagesDisp' : stile[idx])
					  );
					setImgbtn(prevItems => 
						prevItems.map((item, idx) => idx === a ? <PiMinusCircle /> : imgbtn[idx])
					  );	
				}
																		
	}
	const getCollectionImageAvailability=async(id)=>{
		let endpoint = process.env.REACT_APP_PHP_URL+'vehicle-galleries';
        const formData = {vehicle_id:id,gallery_type:'collection'}
        const BEARER_TOKEN = token;
        try{
            const response=await axios(endpoint, {
            method: "POST",
            data:formData,
            withCredentials: true,
            headers: {
                'Authorization': `Bearer ${BEARER_TOKEN}`,
                'Content-Type': 'application/json',
            }
            })
			return(response.data.data);
            }
            catch(error) {
			return([]);
            };
	}
	const getDeliveryImageAvailability=async(id)=>{
		let endpoint = process.env.REACT_APP_PHP_URL+'vehicle-galleries';
        const formData = {vehicle_id:id,gallery_type:'delivered'}
        const BEARER_TOKEN = token;
        try{
            const response=await axios(endpoint, {
            method: "POST",
            data:formData,
            withCredentials: true,
            headers: {
                'Authorization': `Bearer ${BEARER_TOKEN}`,
                'Content-Type': 'application/json',
            }
            })
			return(response.data.data);
            }
            catch(error) {
			return([]);
            };
	}	
	const saveCollection=async()=>{		
		setErrcustomername('');
		setErrcustomersign('');
		let imagecnt=1;
		for(let i=0;i<vehiclesdata.length;i++)
		{
			document.getElementById("imgMsg"+vehiclesdata[i]['id']).innerHTML="";
			const test=await getCollectionImageAvailability(vehiclesdata[i]['id']);
			if (test.length === 0 && imagecnt!==0) {
				document.getElementById("imgMsg"+vehiclesdata[i]['id']).innerHTML="* Please upload atleast one collection image";
				setStile(prevItems => 
					prevItems.map((item, idx) => idx === i ? 'storedImagesDisp' : stile[idx])
				  );
				setImgbtn(prevItems => 
					prevItems.map((item, idx) => idx === i ? <PiMinusCircle /> : imgbtn[idx])
				  );	
				document.getElementById('imageblock'+vehiclesdata[i]['id']).scrollIntoView({ behavior: 'smooth' });
				imagecnt=0;
			}
		}
		if(imagecnt===0)
		{
			//setErrcustomersign('* Atleast one image should be in image block');
		}
		else if(customername==='' || customername===null)
			{
				setErrcustomername('* Customer name is mandatory');
				document.getElementById("customerName").focus();
			}
		else if(signature==='' || signature===null)
			{
				setErrcustomersign('* Customer signature is mandatory');
			}
		else
			{
				let endpoint = process.env.REACT_APP_PHP_URL+'job-collection-update';
				const formData = {contact_name:customername,job_id:id,collection_notes:customernote,collection_signature:signature}
				  const BEARER_TOKEN = token;
				try{
				  const response=await axios(endpoint, {
					method: "POST",
					data:formData,
					withCredentials: true,
					headers: {
					  'Authorization': `Bearer ${BEARER_TOKEN}`,
					  'Content-Type': 'application/json',
				  }
					});
						//LoadJob();
						//setDeliveryMark1('blockDiv');
						//setDeliveryMark2('clearDiv');
						window.location.reload();
					}catch(error) {
						if(error.response.data.message!==undefined)
                		{
						if(error.response.data.message.contact_name!==undefined)
							{
								setErrcustomername(error.response.data.message.contact_name[0]);
							}
						if(error.response.data.message.collection_signature!==undefined)
							{
								setErrcustomersign(error.response.data.message.collection_signature[0]);
							}
						}
						else{
							setErrcustomersign('Something went wrong!!');
							navigate('/');
						}
					}
			}
	}
	const saveDelivery=async()=>{	
		setErrcustomername('');
		setErrcustomersign('');		
		let imagecnt=1;
		for(let i=0;i<vehiclesdata.length;i++)
		{
			document.getElementById("imgMsg"+vehiclesdata[i]['id']).innerHTML="";
			const test=await getDeliveryImageAvailability(vehiclesdata[i]['id']);
			if (test.length === 0 && imagecnt!==0) {
				document.getElementById("imgMsg"+vehiclesdata[i]['id']).innerHTML="* Please upload atleast one delivery image";
				setStile(prevItems => 
					prevItems.map((item, idx) => idx === i ? 'storedImagesDisp' : stile[idx])
				  );
				setImgbtn(prevItems => 
					prevItems.map((item, idx) => idx === i ? <PiMinusCircle /> : imgbtn[idx])
				  );	
				document.getElementById('imageblock'+vehiclesdata[i]['id']).scrollIntoView({ behavior: 'smooth' });
				imagecnt=0;
			}
		}
		if(imagecnt===0)
		{
			//setErrcustomersign('* Atleast one image should be in image block');
		}
		else if(customername==='' || customername===null)
			{
				setErrcustomername('* Customer name is mandatory');
				document.getElementById("customerName").focus();
			}
		else if(signature==='' || signature===null)
			{
				setErrcustomersign('* Customer signature is mandatory');
			}
		else
			{
				let endpoint = process.env.REACT_APP_PHP_URL+'job-delivery-update';
				const formData = {contact_name:customername,job_id:id,delivery_notes:customernote,delivery_signature:signature}
				const BEARER_TOKEN = token;
				try{
				const response=await axios(endpoint, {
					method: "POST",
					data:formData,
					withCredentials: true,
					headers: {
					  'Authorization': `Bearer ${BEARER_TOKEN}`,
					  'Content-Type': 'application/json',
				  }
					});
						LoadJob();
						//window.location.reload();
				}catch(error) {
					if(error.response.data.message!==undefined)
                		{
						if(error.response.data.message.contact_name!==undefined)
							{
								setErrcustomername(error.response.data.message.contact_name[0]);
							}
						if(error.response.data.message.collection_signature!==undefined)
							{
								setErrcustomersign(error.response.data.message.collection_signature[0]);
							}
						}
						else{
							setErrcustomersign('Something went wrong!!');
							navigate('/');
						}
					}			
			}
	}
    function strReplace(str)
	{
		return str;
	}
	function dateConvertion(date)
	{
  if (!date || date.trim() === '') {
    return ''; 
  }

  let cstdate = '';
  try {
    const myArray = date.split(" ");
    const dt = myArray[0].split("-");
    const tm = myArray[1].split(":");

    cstdate = dt[2] + '/' + dt[1] + '/' + dt[0] + ' @ ';

			if (tm[0] < 12) {
				if(tm[0] == 0)
				cstdate = cstdate + '12' + ':' + tm[1] + 'am';
				else
				cstdate = cstdate + tm[0] + ':' + tm[1] + 'am';
			} else {
			if (tm[0] % 12 > 9) {
				cstdate = cstdate + (tm[0] % 12) + ':' + tm[1] + 'pm';
			} else if (tm[0] % 12 == 0) {
				cstdate = cstdate + 12 + ':' + tm[1] + 'pm';
			}
			else {
				cstdate = cstdate + '0' + (tm[0] % 12) + ':' + tm[1] + 'pm';
			}
			}
		} catch (error) {			
			console.error("Error formatting date : ", error);
			return '';
		}

  	return cstdate;
	}
	function dtConvertion(date,type=1)
	{
	if (!date || date.trim() === '') {
		return ''; 
	}
  	let cstdate = '';
	try {
		const myArray = date.split(" ");
		const dt = myArray[0].split("-");
		const tm = myArray[1].split(":");
		if(type==1)
		{
		cstdate = dt[2] + '/' + dt[1] + '/' + dt[0] ;
		}
		else
		{
		if (tm[0] < 12) {
			if(tm[0] == 0)
			cstdate = cstdate + '12' + ':' + tm[1] + 'am';
			else
			cstdate = cstdate + tm[0] + ':' + tm[1] + 'am';
			} else {
			if (tm[0] % 12 > 9) {
				cstdate = cstdate + (tm[0] % 12) + ':' + tm[1] + 'pm';
			}else if (tm[0] % 12 == 0) {
				cstdate = cstdate + 12 + ':' + tm[1] + 'pm';
			} else {
				cstdate = cstdate + '0' + (tm[0] % 12) + ':' + tm[1] + 'pm';
			}
			}
		}
		} catch (error) {			
			console.error("Error formatting date:", error);
			return '';
		}
  	return cstdate;
	}

	return (<>
		<Navbar />
		{data.map((item,index3) => (
		<div key="jobkey" className="container">
		  <div className="row">
		  {item.status !== 'Delivered' ? (
			<div className="col-sm-12" key="jobkey1">
				<div className="card">
					  <div className="card-body">
						<h5 className="card-title">
						<b>{item.business_name}</b>
						</h5>
					<p className="card-text">#{item.id<10?'00'+item.id:item.id<100?'0'+item.id:item.id}</p>
					{(item.admin_notes_public !== '') && (item.admin_notes_public !== null) ? (
					<>
					<h6 className="card-title">
						<b>Notes</b>
					</h6>
						<p className="card-text">{item.admin_notes_public}</p>
					</>
					):''}
					</div>
					<br/>
				</div>
			</div>
			):(
				<div className="col-sm-12" key="jobkey2">
				<div className="card custom-card">
					  <div className="card-body">
						<h5 className="card-title">
						<FaRegCheckCircle className="checkCircle"/>
						<span className="completedtitle">{item.business_name}</span>
						</h5>
					<p className="card-text">#{item.id<10?'00'+item.id:item.id<100?'0'+item.id:item.id}</p>
					{(item.admin_notes_public !== '') && (item.admin_notes_public !== null) ? (
					<>
					<h6 className="card-title">
						<b>Notes</b>
					</h6>
						<p className="card-text">{item.admin_notes_public}</p>
					</>
					):''}
					</div>
					<br/>
				</div>
			</div>
			)}
			{vehiclesdata.map((item1,index1) => (
					<div className="col-sm-12" key={'jobkey3'+index1}>
						<div className="card">
							<div className="card-body" id={'imageblock'+item1.id}>							
							<a onClick={()=>openImageBlock(index1)}><table><tbody><tr><td style={{width:'94%'}}><p className="card-text jobsImg" style={{marginBottom: '0px',fontWeight:'600'}}><b>Vehicle{index1+1} : </b>{item1.condition} {item1.type}, {item1.make} {item1.model}, {item1.registration}</p></td><td className='fafa' valign="middle">{imgbtn[index1]}</td></tr></tbody></table></a>
								<div id="images1" className={stile[index1]}>
									<div className="invalid-feedback" id={'imgMsg'+item1.id}></div>
									<div className="image-collection-heading"><b>Collection Images</b></div>									
									<CollectionImages jobid={item1.id} jid={id} len={vehiclecnt} jobstatus={item.status}/>										
								</div>
								{(item.status=='Ready to deliver'||item.status=='Delivered')&&(
								<div id="images2" className={stile[index1]}>
									<div className="image-deliver-heading"><b>Delivery Images</b></div>
									<div className="invalid-feedback" id={'imgMsgDelivery'+item1.id}></div>
									<DeliveryImages jobid={item1.id} jobstatus={item.status}/>										
								</div>	
								)}							
							</div>
						</div>
					</div>
			))}
			{item.status === 'Ready to collect' ? (
			<>
			<div className="col-sm-12" key="jobkey4">
				<div className="card">
					  <div className="card-body">
						<h5 className="card-title">
						<b>Collection <span  style={{float: 'right',right: '15px',position: 'absolute',fontSize: '1rem'}}>{dtConvertion(item.collection_date)}<br/>{dtConvertion(item.collection_date,2)}</span></b> 
						</h5>
						<div className="card-text" style={{marginTop: '20px'}}>
							{item.collection_address.split("\n").map((line, index) => (
        					<div key={index}>{line}</div>
      						))} 
						</div>   		
						<a type="submit" className="googlebtn btn btn-primary center" href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(item.collection_address)}`} target="_blank">View on Google maps</a><br/>
						<div className={deliveryMark1}><a type="submit" className="loginbtn btn btn-primary center" onClick={openCollectionBlock}>Mark as Collected</a></div>
						<div className={deliveryMark2}>
						<div key="collection1"><p></p>
						<label htmlFor="note" className="form-label"><h5>Notes</h5></label>
			  			<textarea className="form-control" id="note" rows="3" onChange={(e) => setCustomernote(e.target.value)}></textarea>
			  			<br/>
			  			<label htmlFor="customerName" className="form-label"><h5>Customer Name</h5></label>
						<input type="text" className="form-control" id="customerName" aria-describedby="customerName" onChange={(e) => setCustomername(e.target.value)} />
						<div className="invalid-feedback">{errcustomername}</div>
			  			<br/>
			  			<label htmlFor="sign" className="form-label"><h5>Customer Signature</h5></label>
						</div>	
						<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>					
						{!isSignatureVisible && (
							
							<SignatureCanvas 
							id="signcanvas"
							penColor="black"
							backgroundColor="white"
							canvasProps={{
							  width: canvasWidth,
							  height: 200,  
							  className: 'sigCanvas',
							}}

								ref={sigRef}
								onEnd={handleSignatureEnd}
								/>
							
							)}
							</div>
							<div className={deliveryMark2}>	
							<div className="invalid-feedback">{errcustomersign}</div>
							<br/>										               
							<button className="loginbtn btn btn-primary center" id="btnSub" style={{backgroundColor:'red'}} onClick={clearSignature}>Clear</button>
							<br/>
			  				<a type="submit" className="loginbtn btn btn-primary center" onClick={saveCollection}>Mark as Collected</a>
							</div>						
						</div>			
					</div>
					<br/>
				</div>
			</div>
		<div className="col-sm-12" >
			<div className="card">
				  <div className="card-body">
					<h5 className="card-title">
					<b>Delivery <span  style={{float: 'right',right: '15px',position: 'absolute',fontSize: '1rem'}}>{dtConvertion(item.delivery_date)}<br/>{dtConvertion(item.delivery_date,2)}</span></b> 
					</h5>
					<div className="card-text" style={{marginTop: '20px'}}>
						{item.delivery_address.split("\n").map((line, index) => (
						<div key={index}>{line}</div>
						))} 
					</div>
					<a type="submit" className="googlebtn btn btn-primary center" href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(item.delivery_address)}`} target="_blank">View on Google maps</a>
				</div>
				<br/>
			</div>
		</div>
		</>	
			):item.status === 'Ready to deliver' ? (			
				<>
				<div className="col-sm-12" >
					<div className="card">
						  <div className="card-body">
							<h5 className="card-title">
							<b>Delivery <span  style={{float: 'right',right: '15px',position: 'absolute',fontSize: '1rem'}}>{dtConvertion(item.delivery_date)}<br/>{dtConvertion(item.delivery_date,2)}</span></b> 
							</h5>
							<div className="card-text" style={{marginTop: '20px'}}>
							{item.delivery_address.split("\n").map((line, index) => (
								<div key={index}>{line}</div>
							))} 
							</div>   		
							<a type="submit" className="googlebtn btn btn-primary center"  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(item.delivery_address)}`} target="_blank">View on Google maps</a><br/>
							<div className={deliveryMark1}><a type="submit" className="loginbtn btn btn-primary center" onClick={openCollectionBlock}>Mark as Delivered</a></div>
							<div className={deliveryMark2}>
							<div key="collection1"><p></p>
							<label htmlFor="note" className="form-label"><h5>Notes</h5></label>
							  <textarea className="form-control" id="note" rows="3" onChange={(e) => setCustomernote(e.target.value)}></textarea>
							  <br/>
							  <label htmlFor="customerName" className="form-label"><h5>Customer Name</h5></label>
							  <input type="text" className="form-control" id="customerName" aria-describedby="customerName" onChange={(e) => setCustomername(e.target.value)} />
							  <div className="invalid-feedback">{errcustomername}</div>
							  <br/>
							  <label htmlFor="sign" className="form-label"><h5>Customer Signature</h5></label>
							</div>	
							<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>											
							  {!isSignatureVisible && (
							<SignatureCanvas 
							penColor="black"
							backgroundColor="white"
							canvasProps={{
							  width: canvasWidth,
							  height: 200,  
							  className: 'sigCanvas',
							}}

								ref={sigRef}
								onEnd={handleSignatureEnd}
								/>
							)}					
							</div>
								<div className={deliveryMark2}>		
								  <div className="invalid-feedback">{errcustomersign}</div>
								  <br/>												               
								  <button className="loginbtn btn btn-primary center" id="btnSub" style={{backgroundColor:'red'}} onClick={clearSignature}>Clear</button>
								  <br/>
								  <a type="submit" className="loginbtn btn btn-primary center" onClick={saveDelivery}>Mark as Delivered</a>
								</div>						
							</div>			
						</div>
						<br/>
					</div>
				</div>
				<div className="col-sm-12">
					<div className="card  custom-card">
						<div className="card-body">
							<h5 className="card-title">
							<FaRegCheckCircle className="checkCircle"/>
							<span className="completedtitle">Collection Completed</span>
							</h5>
							<div className="card-text"> {item.collection_address.split("\n").map((line, index) => (
        							<div key={index}>{line}</div>
      							))}
							</div>
								<center><div className="completedblock btn btn-primary"><FaRegCheckCircle className="checkCircle"/><span className="completeddate">Collected - {dateConvertion(item.collection_date)}</span></div></center>
						</div>
					</div>
				</div>
			</>	

			):item.status === 'Delivered' ? (
			<><div className="col-sm-12">
			<div className="card  custom-card">
				  <div className="card-body">
					<h5 className="card-title">
					<FaRegCheckCircle className="checkCircle"/>
					 <span className="completedtitle">Delivery Completed</span>
					</h5>
					<div className="card-text">
					{item.delivery_address.split("\n").map((line, index) => (
						<div key={index}>{line}</div>
						))} 
					</div>
						<center><div className="completedblock btn btn-primary"><FaRegCheckCircle className="checkCircle"/><span className="completeddate">Delivered - {dateConvertion(item.delivery_date)}</span></div></center>
				  </div>
			</div>
		</div>
		<div className="col-sm-12">
			<div className="card  custom-card">
				  <div className="card-body">
					<h5 className="card-title">
					<FaRegCheckCircle className="checkCircle"/>
					<span className="completedtitle">Collection Completed</span>
					</h5>
					<div className="card-text">
						{item.collection_address.split("\n").map((line, index) => (
        				<div key={index}>{line}</div>
      					))}
					</div>
					<center><div className="completedblock btn btn-primary"><FaRegCheckCircle className="checkCircle"/><span className="completeddate">Collected - {dateConvertion(item.collection_date)}</span></div></center>
				  </div>
			</div>
		</div> </>
			):(			<><div className="col-sm-12">
			<div className="card  custom-card">
				  <div className="card-body">
					<h5 className="card-title">
					 <b>Delivery</b>
					</h5>
					<div className="card-text">
					{item.delivery_address.split("\n").map((line, index) => (
						<div key={index}>{line}</div>
						))} 
					</div>
						<center><div className="completedblock btn btn-primary"><span>{dateConvertion(item.delivery_date)}</span></div></center>
				  </div>
			</div>
		</div>
		<div className="col-sm-12">
			<div className="card  custom-card">
				  <div className="card-body">
					<h5 className="card-title">
					<b>Collection</b>
					</h5>
					<div className="card-text">
						{item.collection_address.split("\n").map((line, index) => (
        				<div key={index}>{line}</div>
      					))}
					</div>
					<center><div className="completedblock btn btn-primary"><span>{dateConvertion(item.collection_date)}</span></div></center>
				  </div>
			</div>
		</div> </>)} 	
			<div className="col-sm-12"></div>
		  </div>
		</div>	
		))}
	</>);

}
export default Jobs;
